import React, { useCallback, useState } from 'react';
import { Table, Space, Button, Popconfirm, Spin } from 'antd';
import { 
  TableWrapper,
  PaymentRequestModal, 
  PaymentModal } from 'components/molecules';
import { usePopupManager } from 'react-popup-manager';
import { ColumnsType } from 'antd/lib/table/interface';
import { TotalNumMenu } from 'components/atoms';
import { useLocation, useNavigate } from 'react-router';
import { addNewSearch } from 'utils/utils';
import { useTableInfo } from 'hooks';
import { INIT_PAGESIZE } from 'commons/constants';
import qs from 'query-string';
import * as XLSX from 'xlsx';
import { fetcher } from 'services';

interface FormItemProps {
  paymentList: PaymentListDto[] | undefined;  
  searchResult: any;
  hiddenColumns: string[];
  refetch: () => void;
  refetch2?: () => void;
  onhidden?: (id: number) => void;    
}

const PAYTable = ({paymentList, searchResult, hiddenColumns, refetch, refetch2, onhidden}: FormItemProps): React.ReactElement => {
  /* ======================================================
   * variables
   * ====================================================== */
  const [isLoding, setIsLoading] = useState<boolean>(false); 
  const navigate = useNavigate();
  const location = useLocation();
  const { open } = usePopupManager();
  const searchParams = qs.parse(location.search);
  const columns: ColumnsType<PaymentListDto> = [
    {
      title: '번호',
      dataIndex: 'id',
      key: 'id',
      width: '70px',
      align: 'center',
    }, 
    {
      title: '상태',
      dataIndex: 'status_type',
      key: 'status_type',
      width: '70px',
      align: 'center',      
    },       
    {
      title: '발행대상',
      dataIndex: 'lecturer_name',
      key: 'lecturer_name',
      width: '200px',
      align: 'center',
      ellipsis: true,
      render: (lecturer_name, record) => {
        return (
          <label>{(record.read_cnt===0) && (<span style={{color:'#FF0000', fontSize:'8px'}}>New&nbsp;</span>)}[{record.lecturer_type}]{lecturer_name}</label>
        )
      }  
    },
    {
      title: '고객사',
      dataIndex: 'company_name',
      key: 'company_name',
      width: '120px',
      align: 'left',
      ellipsis: true,
    },     
    {
      title: '지급항목',
      dataIndex: 'project_title',
      key: 'project_title',
      width: 'auto',
      align: 'left',
      ellipsis: true,
    },   
    {
     title: '금액',
     dataIndex: 'payment_price',
     key: 'payment_price',
     width: '120px',
     align: 'right',
     ellipsis: true,
     render: (payment_price, record) => {
      return (
        payment_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")+'원'
      )
    }      
   },  
   {
    title: '요청자',
    key: 'who_create',
    dataIndex: 'who_create',
    width: '120px',
    align: 'center',     
  },    
   {
    title: '지급일',
    key: 'payment_day',
    dataIndex: 'payment_day',
    width: '120px',
    align: 'center',     
  }, 
  {
    title: '메모',
    dataIndex: 'memo',
    key: 'memo',
    width: '200px',
    align: 'left',
    ellipsis: true,      
  },    
  {
    title: '확인일',
    dataIndex: 'confirm_at',
    key: 'confirm_at',
    width: '120px',
    align: 'center',    
  }, 
   {
    title: '등록일',
    dataIndex: 'created_at',
    key: 'created_at',
    width: '120px',
    align: 'center',    
  }, 
  {
    title: '재요청일',
    dataIndex: 'confirm_at',
    key: 're_request_at',
    width: '120px',
    align: 'center',    
  },   
  {
    title: '반려일',
    dataIndex: 'confirm_at',
    key: 'drop_at',
    width: '120px',
    align: 'center',    
  },
  {
    title: '반려사유',
    dataIndex: 'drop_memo',
    key: 'drop_memo',
    width: 'auto',
    align: 'center',    
  },  
  {
    title: '숨김',
    key: 'hidden',
    width: '70px',
    align: 'center', 
    onCell: (record) => {
      return {
          onClick: (e) => {
            e.stopPropagation();
          },
      };
    },        
    render: (text, record) => {
      return (
        <Popconfirm
          title="선택하신 반려 항목을 숨김 처리 하시겠습니까?"
          okText="숨김"
          cancelText="취소"
          onConfirm={() => {
            onhidden?.(record.id);
          }}
          >   
            <Button
              type='default'
            >숨김</Button>
        </Popconfirm>
      )
    }    
  },    
  {
    title: '발행',
    key: 'request',
    width: '70px',
    align: 'center',  
    render: (text, record) => {
      return (
        <Button
          type='primary'
          disabled={record.out_lecturer_price_yn === 'Y' || record.lecturer_type ==='내부강사'}
          onClick={(e) => {
            e.stopPropagation();
            open(PaymentRequestModal, {
              id: record.group_srl,
              group: record.schedule_group,
              onClose: (isOk) => {
                if (isOk) {
                  //refetch();
                }
              },
            }); 
          }}
        >발행</Button>
      )
    }      
  },             
  ];

  /* ======================================================
  * events
  * ====================================================== */ 
  const onChangePageInfo = (pageNo: number, pageSize: number) => {
    navigate({
      ...location,
      search: addNewSearch(location.search, { pageNo, pageSize }),
    });
  };  
 
  const onRowClick = useCallback((record, index) => {
   return {
     onClick: () => {
       open(PaymentModal, {id: Number(record.id), onClose: (isOk)=>{refetch(); refetch2?.();}}); 
     },
   };
  }, []);
 
 
  const onExcelDownload = () => {
    setIsLoading(true); 

    fetcher.payment.postPaymentList({
      pageNo: 1,
      pageSize: 0,
      searchValue: searchParams.search ? String(searchParams.search) : '',  
      searchDateStart: searchParams.searchDateStart ? String(searchParams.searchDateStart) : '',   
      searchDateEnd: searchParams.searchDateEnd ? String(searchParams.searchDateEnd) : '',  
      pm: searchParams.pm ? String(searchParams.pm) : '',   
      status: searchParams.status ? String(searchParams.status) : 'request', 
    })
    .then((res) => {
        switch (res.code) {
            case 200:

            const book = XLSX.utils.book_new();
            const nurses = XLSX.utils.json_to_sheet(
              res.result?res.result.list.map((item: PaymentListDto, index) => {
                return {
                  '번호': item.id,
                  '상태': item.status_type,
                  '발행대상': '['+item.lecturer_type+']'+item.lecturer_name,
                  '고객사': item.company_name,
                  '지급항목': item.project_title,
                  '금액': item.payment_price,
                  '요청자': item.who_create,
                  '지급일': item.payment_day,
                  '메모': item.memo,
                  '확인일': item.confirm_at,
                  '등록일': item.created_at,
                }
              }):[], 
              { 
                header : [
                  '번호',
                  '상태',
                  '발행대상',
                  '고객사',
                  '지급항목',
                  '금액',
                  '요청자',
                  '지급일',
                  '메모',
                  '확인일',
                  '등록일',
                ], 
                skipHeader : false 
              } 
            );
        
            nurses["!cols"] = [
              { wpx : 60 } 
            , { wpx : 100 } 
            , { wpx : 120 } 
            , { wpx : 120 }
            , { wpx : 300 }  
            , { wpx : 100 }  
            , { wpx : 80 } 
            , { wpx : 100 } 
            , { wpx : 200 } 
            , { wpx : 100 } 
            , { wpx : 100 } 
            ]
        
            XLSX.utils.book_append_sheet( book, nurses, "NURSES" );
            XLSX.writeFile( book, "외부강사료지급현황.xlsx" ); 
            
            break;
            default:  
            break;
        };
        setIsLoading(false);         
    }); 
  }  

  /* ======================================================
  * hooks
  * ====================================================== */
  const { pagination, onTableChange } = useTableInfo({
    pageInfo: {
      pageNo: Number(searchParams.pageNo) || 1,
      pageSize: Number(searchParams.pageSize) || INIT_PAGESIZE,
    },
    datas: paymentList,
    totalCount: searchResult.totalCount,
    onChangePageInfo,
  });

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <Spin spinning={isLoding} tip="처리중입니다. 잠시만 기다려 주세요." size="large">
        <TotalNumMenu totalNum={searchResult.totalCount} useExcelDownload onDownloadExcel={onExcelDownload}/>
        <TableWrapper isSearch={!!searchParams.search || !!searchParams.lecturer_type || !!searchParams.lecturer_category}>
          <Table
            tableLayout="fixed"
            dataSource={paymentList}
            columns={columns.filter((item) => hiddenColumns.findIndex((col)=>col === item.key) < 0)}
            pagination={pagination}
            onChange={onTableChange}
            onRow={onRowClick}
            style={{ width: '100%', overflowX: 'auto', minWidth: 600 }}
            className="columnCenterFixTable clickable"
            showSorterTooltip={false}
            rowKey={'id'}
          />
        </TableWrapper>  
      </Spin>
    </Space>
  );
};

export default PAYTable;
